/**
 * Dados legais da empresa usados na Política de Privacidade (/privacidade)
 *
 * Preencha todos os campos e peça a revisão jurídica do texto
 * (privacyPolicy.ts). Enquanto algum campo estiver vazio, a página aparece
 * como RASCUNHO, fica fora dos buscadores (noindex e fora do sitemap) e não
 * é linkada no rodapé, no aviso de cookies nem no cadastro.
 *
 * Ver perguntas_ou_pendencias.md (Pendência 022).
 *
 * @author Equipe VendeAi
 * @since 1.4.0
 */

export const LEGAL_COMPANY = {
  /** Razão social */
  legalName: '',
  /** CNPJ (formato 00.000.000/0000-00) */
  document: '',
  /** Endereço da sede */
  address: '',
  /** Nome do encarregado pelo tratamento de dados (DPO) */
  dpoName: '',
  /** E-mail para pedidos de titulares (definido pelo usuário em 27/09/2026) */
  dpoEmail: 'dpo@vendeai.net.br',
  /** Provedor e país onde os servidores estão (ex.: "Hostinger, Brasil") */
  hosting: '',
  /** Data da versão em vigor (AAAA-MM-DD) */
  effectiveDate: '',
};

/** Todos os dados preenchidos: a política pode ser publicada */
export const PRIVACY_POLICY_READY = Object.values(LEGAL_COMPANY).every(v => v.trim() !== '');

/** Caminho da política publicada no site */
export const PRIVACY_PATH = '/privacidade';

/**
 * Endereço da política a exibir nos links: o cadastrado no Super Admin tem
 * prioridade; senão, a página do site, quando estiver pronta.
 */
export function privacyHref(configuredUrl?: string | null): string | null {
  if (configuredUrl) return configuredUrl;
  return PRIVACY_POLICY_READY ? PRIVACY_PATH : null;
}
